import React, { FC, ReactNode } from 'react';

import { Badge as ChakraBadge } from '@chakra-ui/react';
import { BadgeVariant, ColorScheme } from './types';
import { Icon, IconProps } from '../Icon';
import { Typography } from '../Typography';

interface Props {
  variant?: BadgeVariant | undefined;
  colorScheme?: ColorScheme;
  size?: string;
  children?: ReactNode;
  icon?: IconProps;
  textStyle?: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
  isRound?: boolean;
}

export const Badge: FC<Props> = ({
  variant = BadgeVariant.subtle,
  colorScheme = 'gray',
  textStyle,
  icon,
  children,
  size,
  onClick,
  ...rest
}: Props) => {
  return (
    <ChakraBadge
      data-object-type="badge"
      variant={variant}
      colorScheme={colorScheme}
      size={size}
      onClick={onClick}
      textStyle={textStyle}
      {...rest}
    >
      {!!icon && !!icon.iconName && <Icon {...icon} />}
      <Typography as="span" textStyle={textStyle}>
        {children}
      </Typography>
    </ChakraBadge>
  );
};
